import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import defaultStyles from './ListView.module.css';
import jlrStyles from './ListViewJlr.module.css';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import { setStylesAccordingToPlant } from '../../utils/utils';
import { AGGREGATE_SUBCOLUMN } from '../../constants';
import Notification from '../../images/notification.png';


function ListView({ listItems = [], handleSelection, title }) {
  const [currentSelection, setCurrentSelection] = useState(null);
  const [plant] = usePlantAndLinesStore().plantState;
  const [styles, setStyles] = useState(defaultStyles);
 
  const handleClick = item => {
    handleSelection(item);
    setCurrentSelection(item);
  };

  useEffect(() => {
    setStylesAccordingToPlant(plant, setStyles, defaultStyles, jlrStyles);
  }, [plant]); 

  if (!listItems?.length) return null;

  return (
    <div
      className={clsx(styles.listView, currentSelection && styles.selectedLane)}
    >
      <div className={clsx(styles.scrollContainer, styles.scrollBar)}>
        <span className={styles.listTitle}>{title || 'Select'}</span>
        {listItems?.map(item =>
          item.isDisplayable ? (
            <button
              key={item.label}
              type="button"
              onClick={() => (item.action ? item.action() : handleClick(item))}
              className={clsx(
                item.customLabel ? item.customLabel : '',
                styles.listItem,
                currentSelection === item && styles.selected,
              )}
            >
              {item.label}    
              {item.label === AGGREGATE_SUBCOLUMN.EMERGENCY_AGSN ? (
                  <>
                  <div class={clsx(styles.countNotifcation)}>
                    <img
                      src={Notification}
                      alt="Emergency"
                      className={clsx(styles.icon)}
                    />
                    <span className={clsx(styles.count)}>{item.count}</span>              
                  </div>
                  </> 
                ) : (
                  null
                )}
            </button>
          ) : null,
        )}
      </div>
    </div>
  );
}

ListView.propTypes = {
  listItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      action: PropTypes.func,
      customLabel: PropTypes.string,
    }),
  ),
  handleSelection: PropTypes.func.isRequired,
  title: PropTypes.string,
};

export default ListView;
